import React, {useState} from "react";
import {Link as RouterLink} from "react-router-dom"
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Alert from '@mui/material/Alert';
import {useForm, Controller} from "react-hook-form";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {signInWithEmailAndPassword} from "firebase/auth";
import {getFirebase} from "../../config/firebase.config";

const schema = yup.object({
    email: yup.string().email("Invalid email address!").required("Email is required!"),
    password: yup.string().required("Password required!"),
}).required();

function LoginPage(props) {
    const {auth} = getFirebase();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const {handleSubmit, control, formState: {errors}} = useForm({
        defaultValues: {email: '', password: ''},
        resolver: yupResolver(schema)
    });
    const onSubmit = async ({email, password}) => {
        try {
            setLoading(true);
            setError(undefined);
            await signInWithEmailAndPassword(auth, email, password);
        } catch (error) {
            setError({message: `Error(${error.code})`})
        } finally {
            setLoading(false);
        }
    };
    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Avatar sx={{m: 1, width: 100, height: 100}} src="/logo.png"/>

                <Typography component="h1" variant="h4">
                    {process.env.REACT_APP_BUSINESS_NAME || "AUTHENTICATE"}
                </Typography>
                <Typography variant="subtitle1" gutterBottom component="div">
                    Missed EVV Login
                </Typography>
                {error && <Alert severity="error">{error.message}</Alert>}
                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{mt: 1}}>
                    <FormControl fullWidth={true}>
                        <Controller
                            name="email"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    label="Employee Email Address"
                                    autoComplete="email"
                                    autoFocus
                                    {...field}
                                    error={!!errors.email}
                                    helperText={errors.email && errors.email?.message}
                                />}
                        />
                    </FormControl>
                    <FormControl fullWidth={true}>
                        <Controller
                            name="password"
                            control={control}
                            render={({field}) =>
                                <TextField
                                    margin="normal"
                                    fullWidth
                                    type="password"
                                    label="Password"
                                    {...field}
                                    error={!!errors.password}
                                    helperText={errors.password && errors.password?.message}
                                    autoComplete="current-password"
                                />
                            }
                        />
                    </FormControl>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{mt: 3, mb: 2}}
                        disabled={loading}
                    >
                        Sign In
                    </Button>
                    {/* Account recovery and registration process */}
                    <Grid container>
                        <Grid item xs>
                            <Link component={RouterLink} to={"/auth/forgot-password"} variant="body2">
                                Forgot password?
                            </Link>
                        </Grid>
                        <Grid item>
                            <Link component={RouterLink} to={"/auth/account-signup"} variant="body2">
                                Don't have an account?
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
}

export default LoginPage;
